import React, { useContext } from "react";
import { GlobalContext } from "./GlobalContext";
import classNames from "classnames";

const whiteLabelLogos: Record<string, string> = { "b181ac95-d818-4e97-912c-bee6826a23b6": "enablers-logo" };
export const UpsolverLogo: React.FC<React.HTMLProps<HTMLDivElement>> = ({ className, ...rest }) => {
  const context = useContext(GlobalContext);
  const organizationId = context?.auth?.currentOrganization?.id;
  return <div className={classNames("top-logo", className, whiteLabelLogos[organizationId])} {...rest} />;
};

export default UpsolverLogo;
